import React from 'react';
import {Range} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/components/Range/Range';
import {useImageRotate} from '~/CreateFabricInvitation/components/PhotoEditor/common/useImageRotate';
import './RotateControl.sass';

const MIN_ROTATION = -180;
const MAX_ROTATION = 180;
const STEP = 30;

export const RotateControl = ({canvas}) => {
  const {rotationValue, handleRotationChange} = useImageRotate(canvas);

  return (
    <div className="rotate-control">
      <div className="rotate-control__slider">
        <Range
          min={MIN_ROTATION}
          max={MAX_ROTATION}
          step={STEP}
          value={rotationValue}
          onChange={handleRotationChange}
          onLocalChange={handleRotationChange}
          hasControls
          hiddenInput
          dataQaId="rotate-slider"
        />
      </div>
    </div>
  );
};
